import { NgModule } from '@angular/core';

import { ClockModule } from './clock/clock.module';

@NgModule({
    imports: [ClockModule],
    exports: [ClockModule],
})
export class WidgetsModule {}
